module.exports = __webpack_public_path__ + "img/phone.355025b5.svg";